import React from 'react';
import { Colors, Sizes } from '@MerchantConfigurator/constants';

const SelectIconButton = ({ selected, onClick, children, style }) => {
  return (
    <div
      style={{
        ...style,
        marginLeft: Sizes.xs,
        marginRight: Sizes.xs,
        height: '36px',
        width: Sizes['2xl'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        ':hover': {
          color: Colors.PUREBLUE
        },
        color: selected ? Colors.PUREBLUE : Colors.VERYDARKGRAYISHBLUE,
        border: 'none'
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default SelectIconButton;
